export type HistoryStatus = 'all' | 'open' | 'handed' | 'cancelled';
export type HistoryPeriod = 'all' | 'today' | '7d' | '30d' | 'custom';
export type HistoryPayment = 'all' | 'paid' | 'pending' | 'refunded';
export type HistoryChannel = 'all' | 'click_and_collect' | 'pos_register';
export type HistorySort =
  | 'newer'
  | 'older'
  | 'due_asc'
  | 'due_desc'
  | 'price_d'
  | 'price'
  | 'items_desc'
  | 'items_asc';

export interface HistoryQuery {
  page: number;
  pageSize: number;
  status: HistoryStatus;
  q: string;
  period: HistoryPeriod;
  // Jours saisis (AAAA-MM-JJ), lus seulement pour la période personnalisée.
  from: string;
  to: string;
  payment: HistoryPayment;
  channel: HistoryChannel;
  sort: HistorySort;
  // Montants en euros ; vide = pas de borne.
  minTotal: number | null;
  maxTotal: number | null;
}

export interface HistoryRow {
  id: string;
  number: number;
  // Le numéro entier affiché (« R42-20250911-000001 ») ; absent, le rang seul.
  orderNumber?: string;
  label: string;
  day: number;
  state: string;
  detail: string;
  amountCents: number;
  negative: boolean;
  itemCount: number | null;
}

export interface HistoryPage {
  rows: HistoryRow[];
  total: number;
}

export const PAGE_SIZES = [10, 25, 50, 100, 200] as const;

export const DEFAULT_HISTORY_QUERY: HistoryQuery = {
  page: 1,
  pageSize: 25,
  status: 'all',
  q: '',
  period: 'all',
  from: '',
  to: '',
  payment: 'all',
  channel: 'all',
  sort: 'newer',
  minTotal: null,
  maxTotal: null,
};
